import axios from 'axios';

export default {
  search: function (request) {
    return axios.get('/api/stepAction/search', { params: request });
  },
};
